import type { FixingMode } from "@/data/fixingMode";
import { isCashFormat } from "../E3Transactions/utils";

/**
 * Type for the price type option structure
 */
export type PriceTypeMap = {
  valorisation: string[];
  NA: string[];
};

/**
 * Default categorisation for price
 */
export const DEFAULT_PRICE_CATEGORISATION: PriceTypeMap = {
  valorisation: [
    "art",
    "jewel",
    "hedge_fund_unlisted",
    "other_alternative_non_listed",
    "building",
    "personal_use_real_estate",
    "fonds_euros",
    "relatives_debt",
    "private_equity_direct",
    "private_equity_fund",
  ],
  NA: ["home_loan", "other_loan"],
};

export function computeFixingMode(
  assetClass2?: string,
  assetName?: string,
): FixingMode | null {
  if (!assetClass2 || !assetName) return null;

  const isCashAsset = isCashFormat(assetName);
  if (isCashAsset) return "NA";

  const asset_class_2 = assetClass2.trim().toLowerCase();
  if (
    DEFAULT_PRICE_CATEGORISATION.valorisation
      .map((s) => s.toLowerCase())
      .includes(asset_class_2)
  )
    return "valorisation";
  if (
    DEFAULT_PRICE_CATEGORISATION.NA.map((value) =>
      value.toLowerCase(),
    ).includes(asset_class_2)
  )
    return "NA";
  return "fixing";
}

const isFiniteNumber = (v: unknown): boolean =>
  typeof v === "number" && Number.isFinite(v);

export const requiresMarketValue = (data: any) => {
  const assetClass2 = data?.e3_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== "valorisation" || isFiniteNumber(data.market_value);
};

export const requiresFixing = (data: any) => {
  const assetClass2 = data?.e3_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== "fixing" || isFiniteNumber(data.fixing);
};
